import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap';
import Toast from '../commons/helpers/toast'; 
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {getUserTimeZone, userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import * as types from '../../actions';
import {addRemoveVehicleFromShiftAction,shiftSummaryAction,shiftSummaryAllCrewAction,listEventShiftCrewAction,availableAffVehicleAction,addAffVehicleShiftAction,removeAffVehicleShiftAction} from '../../actions/eventActions'; // shiftSkillCrewListAction 
import { crewScheduleShiftStatusAction, crewScheduleShiftCheckInAction, crewScheduleShiftCheckOutAction, crewRemovalFromShiftAction } from '../../actions/crewActions'; 
import {TAB1, TAB2, TAB3, TAB4, SHIFT_STATUS, CREW_MAX_RATING,LOGIN_SUPER_ADMIN_GROUP} from '../../configs/staticConfigs';
import {LBL_TEAM,LBL_NOT_SELECTED,LBL_AFF_VEH_DETAILS,LBL_REMOVE_AFF_VEHICLE,LBL_OR,LBL_REMOVE_CREW_VEHICLE,LBL_SELECT_VEHICLE,LBL_QUOTE,LBL_PO,LBL_SHIFT_PREFIX,LBL_SHIFT,LBL_SHIFT_TITLE_SEPARATOR,LBL_DEPARTMENT,LBL_CONTACT_PERSON,LBL_LOG,LBL_HOURS_SHORT,LBL_CREW_REQUIRED,LBL_CREW_REQUESTED,LBL_CREW_REJECTED,LBL_CREW_PENDING,LBL_AFLT_MANAGER,LBL_CLIENT,LBL_SKILLS,LBL_CHIEFS,LBL_SHIFT_SUMMARY, LBL_SHIFT_OVERVIEW } from '../../configs/labelConfigs'; 
import {URL_IMG} from '../../configs/urlConfigs';
import { MSG_CREW_NOT_ACCEPTED,MSG_NOT_FOUND,MSG_SERVER_DATA_FETCH_ERROR, MSG_CREW_SHIFT_STATUS_UPDATED, MSG_CREW_SHIFT_STATUS_ERROR,MSG_CREW_SHIFT_FILLED, MSG_CREW_TIMESLOT_FILLED, MSG_CREW_SHIFT_UNAVAILABLE, MSG_REMOVE_CREW_RELATED_SHIFT, MSG_REMOVE_CREW_NORMAL_SHIFT } from '../../configs/msgConfigs';
import LogComponent from '../commons/logComponent'; 
import CrewCardComponent from './crewCardComponent'; 

import {showShiftDeleteBtn,checkShiftNotCancelled,showShiftCancelBtn} from './eventStatusCheck';

import {converDateToLocal, convertDecimalToHHMM} from '../../utils/commonUtilities';
import {checkPermissions} from '../../utils/permissions'; 

import { showStaffVehicle, showSelectedVehicle } from '../commons/vehicleUtilities'; 

import ModalWindow from '../commons/helpers/modalWindow';

import {format as stringFormat} from 'react-string-format';

class ShiftDetailSlider extends Component {

    constructor(props){
        super(props)
        this.state = {   
            activeTab:TAB1,
            isClientPage:false,
            toastFlag:false,
            toastMessage:'',
            toastSuccess:false,
            logClicked: 0,
            activeShiftSkillId: 0,
            activeShiftSkillName: '',
            activeShiftId: 0,
            activeShiftSkillCrewData: [],
            activeShiftDetails: {},
            schedule_shift_id:null,
            current_shift:'',
            crew_name:'',
            related_shifts:[],
            arrAccepted: [],
            eventShiftCrewList:[]
        }
        this.renderThumb = this.renderThumb.bind(this);

        this.modalConfirmRemove = React.createRef(); 
    }

    crewAcceptRejectRequest = (shiftId,profileId,status) => {
        let dataObj = { shiftId:shiftId, profileId:profileId, status:status}; 
        this.props.crewScheduleShiftStatusAction(dataObj); 
    } 
    
    crewCheckInRequest = (shiftId,profileId,checkin) => { 
        let dataObj = { shiftId:shiftId, profileId:profileId, checkin:checkin}; 
        this.props.crewScheduleShiftCheckInAction(dataObj); 
    }

    crewCheckOutRequest = (shiftId,profileId,checkout) => {
        let dataObj = { shiftId:shiftId, profileId:profileId, checkout:checkout}; 
        this.props.crewScheduleShiftCheckOutAction(dataObj); 
    } 

    crewRemovalRequest = (schedule_shift_id) => {
        let dataObj = { schedule_shift_id:schedule_shift_id}; 
        this.props.crewRemovalFromShiftAction(dataObj); 
    }

    crewRemoveConfirmed = () =>{
        this.crewRemovalRequest(this.state.schedule_shift_id); 
    }

    onModalFormReset = () =>{
        this.setState({
            schedule_shift_id:null,
            related_shifts:[],
            current_shift:'',
            crew_name:'',
        })
    }

    setScheduleId = (schedule_id,related_shifts,current_shift,crew_name) => {
        this.setState({
            schedule_shift_id:schedule_id,
            related_shifts:related_shifts,
            current_shift:current_shift,
            crew_name:crew_name
        },() => this.openConfirmModal())
    }

    shiftActionBtnClick = (actionType, shiftId, shiftTitle) => {
        if(actionType==='edit'){
            // this.onHideFilterBy(); 
            this.props.editBtnClick(shiftId); 
        }else if(actionType==='delete'){
            // this.onHideFilterBy(); 
            this.props.deleteBtnClick(shiftId,shiftTitle); 
        }else if(actionType==='cancel'){
            this.props.openShiftCancelModal(shiftId); 
        }
        
    }

    scheduleActionClick = (e, eventId,shiftDetails) => {
        e.preventDefault(); 
        this.onHideFilterBy(); 
        // IF CALLED FROM schedule, JUST HIDE THE SLIDER 
        if(this.props.hasOwnProperty("calledFrom") && (this.props.calledFrom==='ShiftList' || this.props.calledFrom==='ScheduleView' || this.props.calledFrom==='scheduleCrew' || this.props.calledFrom==='eventsList')) {
            this.props.loadEventSchedule(eventId,shiftDetails);
        }
    }

    onShowActionButtons = (event) =>{ 
        let dropdownMenu = document.getElementById('dropdown-menu-shift');
        dropdownMenu.classList.toggle('show');      
        // if(this.state.activeRowId===0){   
        //     this.setState({activeRowId:rowId}); 
        // }else if(this.state.activeRowId===rowId){ 
        //     this.setState({activeRowId:0}); 
        // }else if(this.state.activeRowId!==rowId){   
        //     dropdown     = document.getElementById('dropdown-event-'+this.state.activeRowId);
        //     dropdownMenu = document.getElementById('dropdown-menu-event-'+this.state.activeRowId);
        //     dropdown.classList.toggle('show');
        //     dropdownMenu.classList.toggle('show');
        //     this.setState({activeRowId:rowId}); 
        // }        
    }    
  
    onHideActionButtons = (event) =>{
        let dropdownMenu = document.getElementById('dropdown-menu-shift');
        dropdownMenu.classList.remove('show'); 
    } 

    onHideFilterBy = () => {  
        if(this.props.hasOwnProperty("calledFrom") && (this.props.calledFrom==='eventsList')) {
            this.props.showActiveEventDetails();
        }   
        else if(this.props.hasOwnProperty("calledFrom") && (this.props.calledFrom==='ShiftDnDCalendar')) {
            this.props.closeShiftDetails();
        }
        else {
            document.getElementById("filterByMenu").classList.remove('active'); 
            let filterByMenu = document.getElementById('filterByMenu');
            let filterTab = document.getElementById('filterTab');
            let quoteTab = document.getElementById('detailTab');
            filterTab.style.display = 'block';
            quoteTab.style.display = 'none';  
            filterByMenu.style.width='450px';  
            filterByMenu.style.right='-1000px';
            this.setState({activeTab:TAB1}); 
        }
    }

    renderThumb({ style, ...props }) {
        const thumbStyle = {
            backgroundColor: `#083461`,
            padding: 0,
            width:"4px",
            borderRadius:"3px",
        };
        return (
            <div
                style={{ ...style, ...thumbStyle }}
                {...props}/>
        );
    }

    showToaster = (isEnabled,message,isSuccess) => {
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSuccess});
        setTimeout(()=> {
            this.onCloseToast();
        }, 3000);
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    }

    onTabChange = (e,tab,shiftId,skillId,skillName,isChief) =>{
        let logClicked = 0; 
        if(tab===TAB1){
            // this.props.shiftSummaryAllCrewAction(this.props.activeShiftId);  
        } else if(tab===TAB2){
            // this.props.shiftSummaryAction(this.props.activeShiftId);      
        } else if(tab===TAB3){  
            logClicked = 1;        
        }else if(tab===TAB4){  
            this.props.listEventShiftCrewAction(shiftId);  
            this.props.availableAffVehicleAction(shiftId);
        }

        this.setState({activeTab:tab, logClicked:logClicked, activeShiftSkillId: skillId,
            activeShiftSkillName: skillName});  
        // if(skillId > 0) {
        //     this.getShiftSkillCrewData(shiftId,skillId,isChief); 
        // }  
    }
    
    getShiftSkillCrewData = (shiftId,skillId,isChief) => {
        let dataObj = { shiftId:shiftId, skillId:skillId,isChief:isChief }; 
        this.props.shiftSkillCrewListAction(dataObj); 
    }

    openConfirmModal = () =>{
        this.modalConfirmRemove.current.handleOpenModal();
    }   

    componentDidUpdate(prevProps) {
        const { affVehActivity,eventShiftCrewList,subactivity,shiftSliderDetails,shiftSliderStatus,shiftSliderActivity,shiftSkillCrewData,shiftSkillAllCrewData, shiftSkillCrewStatus, shiftSkillCrewActivity, crewScheduleShiftStatus,crewScheduleShiftStatusActivity,crewScheduleShiftStatusErrorData,crewScheduleShiftCheckInStatus,crewScheduleShiftCheckInActivity,crewScheduleShiftCheckOutStatus,crewScheduleShiftCheckOutActivity,crewRemovalStatus,crewRemovalActivity } = this.props;    
        
        if(this.state.activeShiftId!==this.props.activeShiftId) {
            this.setState({ activeShiftId:this.props.activeShiftId }, () => {
                if(this.props.activeShiftId) {
                    this.props.shiftSummaryAction(this.props.activeShiftId); 
                    this.props.shiftSummaryAllCrewAction(this.props.activeShiftId);
                }
                if(this.props.hasOwnProperty("calledFrom") && (this.props.calledFrom==='scheduleCrew' || this.props.calledFrom==='ShiftList')) {
                    this.setState({ activeTab:TAB1 }); 
                }
            }); 
        } 
        
        // ***************************************************************************************** 
        // ********************** CREW REMOVAL FROM SHIFT - START **********************************  
        if(crewRemovalActivity && crewRemovalActivity !== prevProps.crewRemovalActivity && crewRemovalActivity && crewRemovalActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewRemovalActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_REMOVAL_FROM_SHIFT_SUCCESS) {
                if(crewRemovalStatus===200) {
                    // IF CALLED FROM schedule, REFRESH THE REQUIRED, REQUESTED, PENDING NUMBERS
                    if(this.props.hasOwnProperty("calledFrom") && this.props.calledFrom==='scheduleCrew') {
                        this.props.shiftScheduleListAction(this.props.paramId);
                    }
                    // this.setState({ activeShiftId:0 }); // TO REFRESH THE PAGE
                    if(this.state.activeShiftId) {
                        this.props.shiftSummaryAction(this.state.activeShiftId); 
                        this.props.shiftSummaryAllCrewAction(this.state.activeShiftId); // TO REFRESH THE SUMMARY 
                    }
                    this.onTabChange('', this.state.activeTab, this.state.activeShiftId, this.state.activeShiftSkillId, this.state.activeShiftSkillName, 0);
                    this.showToaster(true,MSG_CREW_SHIFT_STATUS_UPDATED,true);                
                }
                else {
                    // {"schedule_user_status":3,"crew_profile_id":144,"shedule_shift_id":626,"message":"Unavailable at requested time"}
                    // console.log('crewRemovalErrorData: '+JSON.stringify(crewRemovalErrorData)); 
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    // if(crewRemovalErrorData.hasOwnProperty('message')) errMsg += ' - '+crewRemovalErrorData.message;
                    this.showToaster(true,errMsg,false);                 
                }
                this.modalConfirmRemove.current.handleModelCloseOnly();
            }
            else if(actString===types.CREW_REMOVAL_FROM_SHIFT_ERROR) {
                // console.log('crewRemovalErrorData: '+JSON.stringify(crewRemovalErrorData)); 
                errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                // if(crewRemovalErrorData.hasOwnProperty('message')) errMsg += ' - '+crewRemovalErrorData.message;
                this.showToaster(true,errMsg,false);   
              
            }
        }
        // ********************** CREW REMOVAL FROM SHIFT - END ************************************
        // *****************************************************************************************




        // ***************************************************************************************** 
        // ********************** CREW ACCEPT STATUS CHECKING - START ******************************  
        if(crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity !== prevProps.crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity && crewScheduleShiftStatusActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewScheduleShiftStatusActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_SCHEDULE_SHIFT_STATUS_SUCCESS) {
                if(crewScheduleShiftStatus===200) {
                    // TO REFRESH THE SUMMARY 
                    if(this.state.activeShiftId) {
                        this.props.shiftSummaryAction(this.state.activeShiftId); 
                        this.props.shiftSummaryAllCrewAction(this.state.activeShiftId); 
                    }
                    this.onTabChange('', this.state.activeTab, this.state.activeShiftId, this.state.activeShiftSkillId, this.state.activeShiftSkillName, 0);
                    this.showToaster(true,MSG_CREW_SHIFT_STATUS_UPDATED,true);   
                    // IF CALLED FROM schedule, REFRESH THE REQUIRED, REQUESTED, PENDING NUMBERS 
                    if(this.props.hasOwnProperty("calledFrom") && this.props.calledFrom==='scheduleCrew') {
                        this.props.shiftScheduleListAction(this.props.paramId);
                    }
                }
                else if(crewScheduleShiftStatus===400) {     
                    // {"schedule_user_status":3,"crew_profile_id":253,"crew_timeslot_filled":true, "crew_unavailable":true,"shedule_shift_id":1234,"message":"timeslot_filled"}  
                    errMsg = MSG_CREW_SHIFT_FILLED;   
                    if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_timeslot_filled') && crewScheduleShiftStatusErrorData.crew_timeslot_filled) errMsg = MSG_CREW_TIMESLOT_FILLED;  
                    else if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_unavailable') && crewScheduleShiftStatusErrorData.crew_unavailable) errMsg = MSG_CREW_SHIFT_UNAVAILABLE;            
                    this.showToaster(true,errMsg,false); 
                }
                else {                    
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    this.showToaster(true,errMsg,false); 
                }
            }
            else if(actString===types.CREW_SCHEDULE_SHIFT_STATUS_ERROR) { 
                if(crewScheduleShiftStatus===400) {      
                    errMsg = MSG_CREW_SHIFT_FILLED; 
                    if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_timeslot_filled') && crewScheduleShiftStatusErrorData.crew_timeslot_filled) errMsg = MSG_CREW_TIMESLOT_FILLED; 
                    else if(crewScheduleShiftStatusErrorData.hasOwnProperty('crew_unavailable') && crewScheduleShiftStatusErrorData.crew_unavailable) errMsg = MSG_CREW_SHIFT_UNAVAILABLE;
                    this.showToaster(true,errMsg,false); 
                }
                else {
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    this.showToaster(true,errMsg,false);  
                }  
            }
        }
        // ********************** CREW ACCEPT STATUS CHECKING - END ********************************
        // *****************************************************************************************

        // ********************************************************************************************* 
        // ********************** CREW CHECKED IN STATUS CHECKING - START ******************************  
        if(crewScheduleShiftCheckInActivity && crewScheduleShiftCheckInActivity !== prevProps.crewScheduleShiftCheckInActivity && crewScheduleShiftCheckInActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewScheduleShiftCheckInActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS) {
                if(crewScheduleShiftCheckInStatus===200) {
                    // TO REFRESH THE PAGE 
                    if(this.state.activeShiftId) {
                        this.props.shiftSummaryAction(this.state.activeShiftId); 
                        this.props.shiftSummaryAllCrewAction(this.state.activeShiftId);
                    }
                    this.onTabChange('', this.state.activeTab, this.state.activeShiftId, this.state.activeShiftSkillId, this.state.activeShiftSkillName, 0);
                    this.showToaster(true,MSG_CREW_SHIFT_STATUS_UPDATED,true);   
                }
                else {
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    // if(crewScheduleShiftCheckInErrorData.hasOwnProperty('message')) errMsg += ' - '+crewScheduleShiftCheckInErrorData.message;
                    this.showToaster(true,errMsg,false);  
                   
                }
            }
            else if(actString===types.CREW_SCHEDULE_SHIFT_CHECKIN_ERROR) {
                errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                // if(crewScheduleShiftCheckInErrorData.hasOwnProperty('message')) errMsg += ' - '+crewScheduleShiftCheckInErrorData.message;
                this.showToaster(true,errMsg,false);
                
            }
        }
        // ********************** CREW CHECKED IN STATUS CHECKING - END ********************************
        // *********************************************************************************************

        // ********************************************************************************************** 
        // ********************** CREW CHECKED OUT STATUS CHECKING - START ******************************  
        if(crewScheduleShiftCheckOutActivity && crewScheduleShiftCheckOutActivity !== prevProps.crewScheduleShiftCheckOutActivity && crewScheduleShiftCheckOutActivity.length > 0) {
            let arrTmp = [];
            arrTmp = crewScheduleShiftCheckOutActivity.split('~~');
            let actString = arrTmp[0]; 
            let errMsg = '';
            if(actString===types.CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS) {
                if(crewScheduleShiftCheckOutStatus===200) {
                    // TO REFRESH THE PAGE 
                    if(this.state.activeShiftId) {
                        this.props.shiftSummaryAction(this.state.activeShiftId); 
                        this.props.shiftSummaryAllCrewAction(this.state.activeShiftId);
                    }
                    this.onTabChange('', this.state.activeTab, this.state.activeShiftId, this.state.activeShiftSkillId, this.state.activeShiftSkillName, 0);
                    this.showToaster(true,MSG_CREW_SHIFT_STATUS_UPDATED,true);
                }
                else {
                    errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                    // if(crewScheduleShiftCheckOutErrorData.hasOwnProperty('message')) errMsg += ' - '+crewScheduleShiftCheckOutErrorData.message;
                    this.showToaster(true,errMsg,false);
                }
            }
            else if(actString===types.CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR) {
                errMsg = MSG_CREW_SHIFT_STATUS_ERROR; 
                // if(crewScheduleShiftCheckOutErrorData.hasOwnProperty('message')) errMsg += ' - '+crewScheduleShiftCheckOutErrorData.message;
                this.showToaster(true,errMsg,false);
              
            }
        }
        // ********************** CREW CHECKED OUT STATUS CHECKING - END ********************************
        // *********************************************************************************************


        if(shiftSliderActivity && shiftSliderActivity !== prevProps.shiftSliderActivity && shiftSliderActivity && shiftSliderActivity.length) {
            let arrTmp = [];
            arrTmp = shiftSliderActivity.split('~~');
            let actString = arrTmp[0]; 

            if(actString===types.SHIFT_SUMMARY_SUCCESS) {
                if(shiftSliderStatus===200) {
                    this.setState({activeShiftDetails:shiftSliderDetails}, () => {
                        // this.onTabChange('', TAB1, 0, 0, '',0); 
                    }); 
                }
                else {
                    this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);                    
                }
            }
            else if(actString===types.SHIFT_SUMMARY_ERROR) {
                this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);            
            } else if(actString===types.SHIFT_SUMMARY_ALL_CREW_SUCCESS) {
                if(shiftSliderStatus===200) {
                    this.setState({activeShiftSkillCrewData:shiftSkillAllCrewData}); 
                }
                else if(shiftSliderStatus!==200) {
                    this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);                  
                }
            }
            else if(actString===types.SHIFT_SUMMARY_ALL_CREW_ERROR) {
                this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);
            }
        }  

        if (subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===types.EVENT_SHIFT_CREW_LIST_SUCCESS){ 
                let shiftCrewList   = []; 
                let arrAccepted     = []; 
                let accepted_count  = 0; 
                if(eventShiftCrewList) { 
                    shiftCrewList   = eventShiftCrewList;
                    arrAccepted     = eventShiftCrewList.accepted ? eventShiftCrewList.accepted : []; 
                    accepted_count  = eventShiftCrewList.accepted_count ? eventShiftCrewList.accepted_count : 0; 
                }
                this.setState({eventShiftCrewList:shiftCrewList,arrAccepted}); 
            }else if(actString===types.ADD_REMOVE_VEHICLE_SHIFT_SUCCESS){
                this.props.listEventShiftCrewAction(this.props.activeShiftId);  
                this.props.availableAffVehicleAction(this.props.activeShiftId);
            } 
        }
        if(affVehActivity && affVehActivity !== prevProps.affVehActivity) {
            let arrResp = affVehActivity.split('~~'); 
            let actString = arrResp[0];
            if(actString===types.ADD_AFF_VEHICLE_SHIFT_SUCCESS){
                this.props.listEventShiftCrewAction(this.props.activeShiftId);  
                this.props.availableAffVehicleAction(this.props.activeShiftId);
            }if(actString===types.REMOVE_AFF_VEHICLE_SHIFT_SUCCESS){
                this.props.listEventShiftCrewAction(this.props.activeShiftId);  
                this.props.availableAffVehicleAction(this.props.activeShiftId);
            } 
        }
            
        

        // if(shiftSkillCrewActivity && shiftSkillCrewActivity !== prevProps.shiftSkillCrewActivity && shiftSkillCrewActivity && shiftSkillCrewActivity) {
        //     let arrTmp = [];
        //     arrTmp = shiftSkillCrewActivity.split('~~');
        //     let actString = arrTmp[0]; 
        //     //let arrData = []; 
        //     if(actString===types.SHIFT_SKILL_CREW_LIST_SUCCESS) {
        //         if(shiftSkillCrewStatus===200) {
        //             this.setState({activeShiftSkillCrewData:shiftSkillCrewData}); 
        //         }
        //         else if(shiftSkillCrewStatus!==200) {
        //             this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);                  
        //         }
        //     }
        //     else if(actString===types.SHIFT_SKILL_CREW_LIST_ERROR) {
        //         this.showToaster(true,MSG_SERVER_DATA_FETCH_ERROR,false);
        //     }
        // }
        

    }

    addRemoveVehicle = (action,scheduleShiftId,vehicleMasterId) =>{
        this.props.addRemoveVehicleFromShiftAction({action:action,schedule_shift_id:scheduleShiftId,vehicle_master_id:vehicleMasterId})
    }
    onHandleVehChange =(e,schedule_id)=>{
        let value = e.target.value;
        this.props.addAffVehicleShiftAction({"schedule_id": schedule_id, "vehicle_id": value});
    }
    removeAffVehChange = (e,schedule_id,vehicle_id)=>{
        this.props.removeAffVehicleShiftAction({"schedule_id": schedule_id, "vehicle_id": vehicle_id});
    }

    render(){
        let timeZone = getUserTimeZone(this.props.location); 
        let shiftDetails = this.state.activeShiftDetails; 
        let {arrAccepted} = this.state;
        let {affAvailVeh} = this.props;
        let isClientPage = this.props.hasOwnProperty('isClientPage') ? this.props.isClientPage : 0; 

        let eventId             = 0;
        let eventTitle          = '';
        let quoteNumber         = '';
        let poNumber            = ''; 
        let shiftId             = 0; 
        let shiftTitle          = '';
        let shiftLocation       = '';
        let shiftNumber         = '';
        let shiftStartDateTime  = ''; 
        let shifEndDateTime     = ''; 
        let shiftLength         = '';
        let arrShiftStatus      = SHIFT_STATUS; 
        let shiftStatus         = ''; 
        let filteredStatus      = [];
        //let totalRequestedCrews = 0; 
        //let totalAssignedCrews  = 0; 
        //let totalRejectedCrews  = 0;
        let isShiftRepeat       = false;
        let departmentName      = '';
        let managerName         = '';  
        let managerPhone        = '';  
        let managerEmail        = '';  
        //let allCrewChiefs     = ''; 
        let clientContactPerson = ''; 
        let clientContactPhone  = ''; 
        let clientContactEmail  = ''; 
        let resources           = 0;
        let shift_skills        = []; 
        let chiefsRequired      = 0;
        let chiefsRequested     = 0;
        let chiefsAssigned      = 0;
        let chiefsPending       = 0;
        let chiefsRejected      = 0;
        let totalRequired      = 0;
        let totalRequested     = 0;
        let totalAssigned      = 0;
        let totalPending       = 0;
        let totalRejected      = 0;
        let showShiftDelete    = true;
        let shiftNotCancelled  = true;
        let showShiftCancel    = false;
        let login_as_sa_user   = 0;
        let special_shift      = false;
        if(shiftDetails.hasOwnProperty('shift_number')) { 
            eventId             = shiftDetails.event_id;
            special_shift       = shiftDetails.special_shift;
            eventTitle          = shiftDetails.event_title; 
            quoteNumber         = shiftDetails.quote_number; 
            poNumber            = shiftDetails.po_number; 
            shiftId             = shiftDetails.shift_id;
            shiftTitle          = shiftDetails.shift_title;
            shiftLocation       = shiftDetails.shift_location.location.location;
            shiftNumber         = LBL_SHIFT_PREFIX+shiftDetails.shift_number;
            // shiftStartDateTime  = shiftDetails.start_datetime;
            // shifEndDateTime     = shiftDetails.end_datetime;
            shiftStartDateTime  = converDateToLocal(shiftDetails.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
            shifEndDateTime     = converDateToLocal(shiftDetails.end_datetime,timeZone.utc_offset,'ddmmyyyyhhmm');
            shiftLength         = convertDecimalToHHMM(shiftDetails.shift_length); 
            isShiftRepeat       = shiftDetails.is_shift_repeat; 
            departmentName      = shiftDetails.department_name;
            managerName         = shiftDetails.manager_name; 
            managerPhone        = shiftDetails.manager_phone; 
            managerEmail        = shiftDetails.manager_email; 
            clientContactPerson = shiftDetails.contact_staff_name && shiftDetails.contact_staff_name.length ? shiftDetails.contact_staff_name : ''; 
            clientContactPhone = shiftDetails.contact_staff_phone && shiftDetails.contact_staff_phone.length ? shiftDetails.contact_staff_phone : '';
            clientContactEmail = shiftDetails.contact_staff_email && shiftDetails.contact_staff_email.length ? shiftDetails.contact_staff_email : ''; 
            
            // totalRequestedCrews = shiftDetails.total_requested_crews; 
            // totalAssignedCrews  = shiftDetails.total_assigned_crews; 
            // totalRejectedCrews  = shiftDetails.total_rejected_crews; 
            
            resources           = shiftDetails.resources;
            shiftStatus         = shiftDetails.status;
            shift_skills        = shiftDetails.shift_skills;
            chiefsRequired      = shiftDetails.chiefs_required;
            chiefsRequested     = shiftDetails.chiefs_requested;
            chiefsAssigned      = shiftDetails.chiefs_assigned;
            chiefsPending       = shiftDetails.chiefs_pending;
            chiefsRejected      = shiftDetails.chiefs_rejected;

            if(shiftStatus!==undefined){
                filteredStatus = arrShiftStatus.filter(x => Number(x.statusCode) ===Number(shiftStatus));
            }
            showShiftDelete = showShiftDeleteBtn(shiftStatus);
            shiftNotCancelled = checkShiftNotCancelled(shiftStatus);
            showShiftCancel   = showShiftCancelBtn(shiftStatus);

        }

        let isSuperAdmin = false; 
        let userGroupData = userGroupUrlCheck(this.props.location);
        let supervisor_name = ''; 
        let lblCrew = 'Staff'; 
        if(userGroupData!==undefined){
            supervisor_name = userGroupData.supervisor_name;
            lblCrew = userGroupData.staff_name?userGroupData.staff_name:'Staff';
            login_as_sa_user = userGroupData.login_as_sa_user; 
            isSuperAdmin = userGroupData.user_group==LOGIN_SUPER_ADMIN_GROUP ? true : false;
        }
        if(!supervisor_name){
            supervisor_name = LBL_CHIEFS;
        }

        let mainTitle = shiftTitle; 
        if(eventTitle.trim().length) mainTitle = shiftTitle+LBL_SHIFT_TITLE_SEPARATOR+eventTitle; 

        let {toastMessage,toastFlag,toastSuccess} = this.state; 
        let dataObj = {refType:LBL_SHIFT, refId:shiftId, logClicked:this.state.logClicked};

        let hideEditDeleteAction = 0;
        if(this.props.hasOwnProperty('hideEditDeleteAction')) hideEditDeleteAction = this.props.hideEditDeleteAction;
        let isViewSchedule = checkPermissions("schedule","view");
        //let disableShiftEdit = shiftEditDisable(shiftStatus);
        let related_shifts = this.state.related_shifts;
        let current_shift = this.state.current_shift;
        let crew_name = this.state.crew_name;
        let MSG_CONFIRMATION = '';
        if(related_shifts.length>0){
            MSG_CONFIRMATION = stringFormat(MSG_REMOVE_CREW_RELATED_SHIFT,crew_name,current_shift+','+related_shifts.join(','));
        }else{
            MSG_CONFIRMATION = stringFormat(MSG_REMOVE_CREW_NORMAL_SHIFT,crew_name,current_shift);
        }
        return(
            <>
                <div className="detail-head border-bottom pb-2 padding-top-7">
                    <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                    <h6><span className="change-count color-red text-bold ">{special_shift?"! ":""}</span>{mainTitle}
                    <button className="close-filter text-muted" onClick={(e) => this.onHideFilterBy()}>
                        <span aria-hidden="true">×</span>
                    </button>
                    </h6>
                    <div className="row">
                        <div className="col-md-3 p-0">{filteredStatus.length>0 && <p className={filteredStatus[0].colorClass+' m-0 status-head'}><small> <i className="fas fa-circle"></i> { isClientPage ? filteredStatus[0].clientStatusString:filteredStatus[0].statusString }</small> </p>}</div>
                        
                        <div className="col-md-3 p-0"><p className="m-0"><small> {shiftNumber}</small></p></div>
                        <div className="col-md-3 p-0"><p className="m-0"><small> {LBL_QUOTE} No: {quoteNumber}</small></p></div>
                        {poNumber && <div className="col-md-3 p-0"><p className="m-0"><small> {LBL_PO} : {poNumber}</small></p></div> }
                    </div>
                </div>
                <Scrollbars style={{ "height": 'calc(100vh - 15vh)',"right":"-18px"}} autoHide renderThumbVertical={this.renderThumb} >
                    <div className="filter-content pt-3">
                        {Number(hideEditDeleteAction)===0 && shiftNotCancelled &&  <div className="dropdown detail-drodown-shift">
                            <button className="dropdown-toggle" type="button" id="dropdownMenuButton-shift" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={(e) => this.onShowActionButtons(e)} onBlur={(e) => this.onHideActionButtons(e)}>
                                    <img src={require('../../'+URL_IMG+'action.png')} alt="Action" />
                            </button>
                            <div className="dropdown-menu" id="dropdown-menu-shift" aria-labelledby="dropdownMenuButton">
                                 <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.shiftActionBtnClick('edit',shiftId,shiftTitle)}>Edit</Link>
                                {showShiftDelete &&
                                    <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.shiftActionBtnClick('delete',shiftId,shiftTitle)}>Delete</Link>
                                }
                                {showShiftCancel &&
                                    <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.shiftActionBtnClick('cancel',shiftId)}>Cancel</Link>
                                }
                                
                            </div>
                        </div>}

                        <p className="mb-0"> 
                            <i className="las la-map-marker-alt"></i><small> {shiftLocation}</small>
                        </p>

                        <p className="pt-0">
                            <small>
                                {/* <span> <i className="las la-calendar-alt"></i> <Moment format="DD/MM/YYYY ">{new Date(shiftStartDateTime)}</Moment> &emsp; to &emsp; <i  className="las la-calendar-alt"></i> <Moment format="DD/MM/YYYY ">{new Date(shifEndDateTime)}</Moment> </span> */}
                                <span> <i className="las la-calendar-alt"></i> {shiftStartDateTime} &emsp; to &emsp; <i  className="las la-calendar-alt"></i> {shifEndDateTime} </span>

                                <span className="ml-5"><i className="las la-clock"></i> {shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()}</span>
                                {isShiftRepeat &&
                                    <OverlayTrigger
                                    placement="right"
                                    delay={{ show: 450, hide: 250 }}
                                    overlay={<Tooltip id="repeat-tooltip" style={{
                                        opacity: 0.4,
                                    }}>
                                    Repeating Shift
                                    </Tooltip>}
                                    >
                                   <span id="repeat" className="ml-5 border-0 repeat-icon"><i className="las la-redo-alt" style={{"fontSize": "20px"}}></i></span>
                                    </OverlayTrigger>
                                 
                                 }
                            </small>
                        </p>

                        <Tab.Container id="shift-details-tab" activeKey={this.state.activeTab}>
                            <Nav variant="pills">

                                <Nav.Item className="min-width-auto" >
                                    <Nav.Link eventKey={TAB1} onClick={(e) => this.onTabChange(e, TAB1, 0, 0, '',0)} >{LBL_SHIFT_SUMMARY} </Nav.Link>
                                </Nav.Item> 

                                <Nav.Item className="min-width-auto" >
                                    <Nav.Link eventKey={TAB2} onClick={(e) => this.onTabChange(e, TAB2, 0, 0, '',0)} >{LBL_SHIFT_OVERVIEW}</Nav.Link>
                                </Nav.Item> 

                                {/* {shift_skills.map(item => { 
                                    if(Number(item.required)) { 
                                        return(<Nav.Item key={item.id}  className="min-width-auto" >
                                            <Nav.Link eventKey={'TAB_SKILL_'+item.id} onClick={(e) => this.onTabChange(e, 'TAB_SKILL_'+item.id, shiftId, item.skill_id, item.skill_name, 0)} >{item.skill_name} </Nav.Link>
                                        </Nav.Item>) 
                                    }})
                                } */}
                                <Nav.Item  className="min-width-auto" >
                                    <Nav.Link eventKey={TAB4} onClick={(e) => this.onTabChange(e, TAB4, shiftId, '', '', '')} >{LBL_TEAM}</Nav.Link>
                                </Nav.Item>
                                <Nav.Item  className="min-width-auto" >
                                    <Nav.Link eventKey={TAB3} onClick={(e) => this.onTabChange(e, TAB3, 0, 0, '', 0)} >{LBL_LOG}</Nav.Link>
                                </Nav.Item>
                                

                            </Nav>   

                            <Tab.Content> 

                                {/* *********** SHIFT SUMMARY TAB - START *********** */}
                                <Tab.Pane eventKey={TAB1} >
                                    {/* <div>{'TAB_SKILL_'+item.id+' : '+item.skill_name}</div> */}
                                    
                                    <CrewCardComponent shiftId={shiftId} activeShiftSkillCrewData={this.state.activeShiftSkillCrewData} activeShiftSkillId={this.state.activeShiftSkillId} activeShiftSkillName={this.state.activeShiftSkillName} crewAcceptRejectRequest={this.crewAcceptRejectRequest} crewCheckInRequest={this.crewCheckInRequest} crewCheckOutRequest={this.crewCheckOutRequest} crewRemovalRequest={this.crewRemovalRequest} setScheduleId={this.setScheduleId} {...this.state}  onTabChange={this.onTabChange} isSuperAdmin={isSuperAdmin} hideAcceptRejectRemoveSchedule={this.props?.hideAcceptRejectRemoveSchedule ? this.props.hideAcceptRejectRemoveSchedule : ''}></CrewCardComponent>
                                    
                                </Tab.Pane>
                                {/* *********** SHIFT SUMMARY TAB - END ************ */}

                                {/* *********** SHIFT OVERVIEW TAB - START *********** */}
                                <Tab.Pane eventKey={TAB2}>
                                    <div className="row mt-12 pb-2 margin-left-10">
                                        <div className="col-md-7 pl-2">
                                            <p className="mb-1"><small>{LBL_DEPARTMENT} : <strong>{departmentName}</strong></small></p>
                                            <p className="mb-1"><small>{LBL_AFLT_MANAGER} : <strong>{managerName} {managerPhone.length ? ' ('+managerPhone+')' : ''}</strong></small></p>
                                            <p className="mb-1"><small>{LBL_CLIENT+' '+LBL_CONTACT_PERSON} : <strong>{clientContactPerson} {clientContactPhone.length ? ' ('+clientContactPhone+')' : ''}</strong></small></p> 
                                            {/* managerEmail  clientContactEmail */}
                                        </div>
                                    </div>  

                                    <div className="row table-responsive mb-3 shift-detail margin-left-10">
                                        <table  className="table border-0"  id="eventdata-table">
                                            <thead className="bg-white">
                                                <tr className="bt-table">
                                                    <th>{LBL_SKILLS}</th> 
                                                    <th className="sorting_disabled text-center">{LBL_CREW_REQUIRED}</th>
                                                    {!this.props.isClientPage && <th className="sorting_disabled text-center">{LBL_CREW_REQUESTED}</th> }
                                                    {!this.props.isClientPage && <th className="sorting_disabled text-center">{LBL_CREW_PENDING}</th> }
                                                    {!this.props.isClientPage && <th className="sorting_disabled text-center">{LBL_CREW_REJECTED}</th> }
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {(shift_skills.length===0)  && 
                                                <tr>
                                                    <td colSpan="5" className="text-center">{MSG_NOT_FOUND}</td>
                                                </tr>
                                            }
                                            {      
                                            shift_skills.map((item, index)  => {
                                                totalRequired      += item.required;
                                                totalRequested     += item.requested;
                                                totalAssigned      += item.assigned;
                                                totalPending       += item.pending;
                                                totalRejected      += item.rejected;
                                                return (
                                                    <tr key={index}>
                                                        <td ><i className={'fas '+item.skill_icon}></i> {item.skill_name}</td>
                                                        <td className="text-center">{item.required}</td>
                                                        {!this.props.isClientPage && <td className="text-center">{item.requested}</td>}
                                                        {!this.props.isClientPage && <td className="text-center">
                                                            {
                                                                shiftNotCancelled && Number(item.pending) > 0 && isViewSchedule && login_as_sa_user===0 && this.props.hideAcceptRejectRemoveSchedule!=='yes' ? 
                                                                <button className="btnWidth50 btn btn-primary launch-modal" onMouseDown={(e) => this.scheduleActionClick(e, eventId,shiftDetails)}  ><i className="las la-plus-circle"></i> {item.pending} </button> : <span>{item.pending}</span> 
                                                            }
                                                            {
                                                                shiftNotCancelled && Number(item.pending) > 0 && isViewSchedule && login_as_sa_user > 0 && 
                                                                <span>{item.pending}</span>
                                                            }
                                                            {
                                                                shiftNotCancelled && Number(item.pending) > 0 && !isViewSchedule &&
                                                                <span>{item.pending}</span>
                                                            }
                                                            {shiftNotCancelled && Number(item.pending)===0 && 
                                                                <span>{item.pending}</span>
                                                            }
                                                            {shiftNotCancelled===false &&
                                                                <span>{item.pending}</span>
                                                            }
                                                            </td> }
                                                            {!this.props.isClientPage && <td className="text-center">{item.rejected}</td> }
                                                    </tr>
                                                ) 
                                            }) }
                                            {(shift_skills.length > 0)  && 
                                                <tr>
                                                    <td ><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img>{supervisor_name}</td>
                                                    <td className="text-center">{chiefsRequired}</td>
                                                    {!this.props.isClientPage && <td className="text-center">{chiefsRequested}</td> }
                                                    {!this.props.isClientPage && <td className="text-center">{chiefsPending}</td> } 
                                                    {!this.props.isClientPage && <td className="text-center">{chiefsRejected}</td> }
                                                </tr>
                                            }
                                            {(shift_skills.length > 0)  && 
                                                <tr className="text-bold">
                                                    <td >Total</td>
                                                    <td className="text-center">{totalRequired}</td>
                                                    {!this.props.isClientPage && <td className="text-center">{totalRequested}</td> } 
                                                    {!this.props.isClientPage && <td className="text-center">{totalPending}</td> } 
                                                    {!this.props.isClientPage && <td className="text-center">{totalRejected}</td> } 
                                                </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </div>                                  
                                </Tab.Pane>
                                {/* *********** SHIFT OVERVIEW TAB - END *********** */ } 

                                {/* *********** SHIFT SKILL CREW DYNAMIC TABS - START *********** */}
                                {/* {shift_skills.map(item => {
                                    if(Number(item.required)) { 
                                        return(<Tab.Pane key={'tabPan_'+item.id} eventKey={'TAB_SKILL_'+item.id} >
                                            <CrewCardComponent shiftId={shiftId} activeShiftSkillCrewData={this.state.activeShiftSkillCrewData} activeShiftSkillId={this.state.activeShiftSkillId} activeShiftSkillName={this.state.activeShiftSkillName} crewAcceptRejectRequest={this.crewAcceptRejectRequest} crewCheckInRequest={this.crewCheckInRequest} crewCheckOutRequest={this.crewCheckOutRequest} crewRemovalRequest={this.crewRemovalRequest} setScheduleId={this.setScheduleId} {...this.state} ></CrewCardComponent>
                                            
                                        </Tab.Pane>)
                                    }})
                                }       */}
                                {/* *********** SHIFT SKILL CREW  DYNAMIC TABS - END *********** */}

                                {/* *********** SHIFT LOG TAB - START *********** */}
                                <Tab.Pane eventKey={TAB3}>
                                    <LogComponent location={this.props.location} dataObj={dataObj} />        
                                </Tab.Pane> 
                                {/* *********** SHIFT LOG TAB - END *********** */}

                                <Tab.Pane eventKey={TAB4}>
                                    <div className={arrAccepted.length ===0?'margin-15 col-md-12 pl-0 pr-0 bg-white':'margin-15 schedule-crew-list-team col-md-12 pl-0 pr-0 bg-white font-13'}>                            
                                    { arrAccepted.length ===0 &&
                                        <div className="crew-list__noitem">{MSG_CREW_NOT_ACCEPTED}</div>
                                    } 

                                    { arrAccepted.map((crew, index)  => {
                                        let crewVehicleAdded = false;
                                        let imageClass = crew.chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                        let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew.crew_name} title={crew.crew_name} />;

                                        if ((crew.profile_picture) && crew.profile_picture.trim().length > 0){
                                            profileImgTag = <img className={imageClass} src={crew.profile_picture} alt={crew.crew_name} title={crew.crew_name} />;
                                        }else if(((!crew.profile_picture) || crew.profile_picture.trim().length===0) && crew.avatar_name && crew.avatar_name.trim().length > 0){
                                            profileImgTag = <div title={crew.crew_name} className={crew.chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crew.profile_color}}>{crew.avatar_name}</div>; 
                                        }

                                        const chiefIcon = crew.is_crew_chief? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                                        const vehicleInfo = <div className="text14Bold paddingBottomp0 vehicle-info-2"><span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span></div>;
                                        let crewRating = crew.crew_total_rating; 
                                        let department = crew.department.length>0?crew.department.map(e => e.name).join(",\r"):''; 

                                        let nameLen = crew.is_crew_chief ? 9 : 12;
                                        let crewFullName = crew.crew_name; 
                                        let crewShortName = crew.crew_name.length > nameLen ? crew.crew_name.substr(0,nameLen)+'...' : crew.crew_name; 
                                        let crewName = crewFullName!==crewShortName ? <OverlayTrigger placement="top"
                                        delay={{ show: 450, hide: 250 }} overlay={<Tooltip id='title-tooltip' style={{ opacity: 0.8, }}> {crewFullName} </Tooltip>} >
                                        <span className="title-tooltip" id="titletip"> {crewShortName} </span>
                                        </OverlayTrigger> : crewFullName;
                                        let phoneNumber = (crew.phone_number && crew.phone_number.length > 0) ? crew.phone_number : (crew.altername_number && crew.altername_number.length > 0) ? crew.altername_number : ''; 

                                        let showVehicleSelection = this.state.eventShiftCrewList?.required_vehicles && this.state.eventShiftCrewList.required_vehicles > 0 && this.state.eventShiftCrewList.assigned_vehicles >= this.state.eventShiftCrewList.required_vehicles ? false : true; 
                                        
                                        return(
                                            <div className="s-crew-border team-border-event-det-team maxHeightNone" key={index}>
                                                <div className="">
                                                    <div className="crew displayItemFlex teamCrew">
                                                        <div className="crew__aside min-width-60">
                                                            <div className="crew__thumb">
                                                                {profileImgTag}
                                                            </div>
                                                            
                                                            <span className="crew__badge font__size__12">{crew.omnu_points}</span>
                                                            <div className="crew__rating rating-display-only">
                                                                {CREW_MAX_RATING.map(ratingNum => {
                                                                    if(Number(ratingNum) <= crewRating) {
                                                                        return(
                                                                        <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum}  data-id={ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                                    )
                                                                    }else{
                                                                        if(parseFloat(ratingNum)-0.5===parseFloat(crewRating)){
                                                                            return(
                                                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                                            )
                                                                        }else{
                                                                            return(
                                                                                <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                                            )
                                                                        } 
                                                                    }                                  
                                                                })
                                                                }
                                                            </div>

                                                            <div className='d-flex align-items-center'>
                                                            {crew.staff_vehicle && crew.staff_vehicle.length>0 && <div className="text14Bold"><span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span></div>}
 
                                                            {crew.drive_to_shift_location && <i class="fas fa-solid fa-id-card mr-2"></i>}
                                                            </div>
                                                        </div>
                                                        <div className="crew__content">
                                                            <div className="crew__desc">
                                                                
                                                                <div className="row paddingLeft15 mb-0 paddingBottomp0">
                                                                    <div className="col8 text14Bold paddingBottomp0 ">{chiefIcon}<b>{crewName}</b> <p className="paddingTop0 paddingBottomp0"><small>{crew.pay_level_name}</small></p>
                                                                    </div>
                                                                </div>
                                                                <div className="row paddingLeft15 paddingTop5 text11 text-muted">{department}</div>
                                                                <div className="row paddingLeft15 mb-0 paddingBottomp0 display-block">
                                                                {crew.skill.skill_name && crew.skill.skill_name.length > 0 && 
                                                                    <React.Fragment >
                                                                        <p className="mb-0"><small><i className={'fas '+crew.skill.skill_icon}></i> {crew.skill.skill_name}</small></p>
                                                                    </React.Fragment> }
                                                                </div>  
                                                                {phoneNumber.length > 0 && <div className="row paddingLeft15 paddingTop5 paddingBottom10 text11 text-muted">{'Ph: '+phoneNumber}</div>}
                                                                                                          
                                                                
                                                            </div> 
                                                        </div>
                                                    </div>
                                                    {crew?.travel_cost_included && crew?.drive_to_shift_location ? 
                                                    <div>

                                                        {!crew.added_affiliate_vehicle && crew.staff_vehicle && crew.staff_vehicle.map((vehicle, index)  => {
                                                        let disableVehicle = false;
                                                        if(crew.shift_status === 7 || crew.shift_status === 8 || isSuperAdmin){
                                                            disableVehicle = true;
                                                        }
                                                        if(vehicle.vehicle_added === true){
                                                                crewVehicleAdded = true;
                                                        }
                                                        return(<div className="vehicleInfo">
                                                            {/* {vehicle.map((info,index)=>{
                                                                let disableVehicle = false;
                                                                if(crew.shift_status === 7 || crew.shift_status === 8 || isSuperAdmin){
                                                                    disableVehicle = true;
                                                                }
                                                                if(info.vehicle_added === false && !this.props.isClientPage && disableVehicle === false){
                                                                    return(<div className="padding-top-10"><a className="textUl blueText spanPointer"  onClick={(e) => this.addRemoveVehicle('add', crew.schedule_id, info.vehicle_master_id)}><span> {info.shift_status} {stringFormat(LBL_SELECT_VEHICLE,lblCrew)}</span></a></div>)
                                                                }
                                                            })} */}
                                                            {/* {vehicle.map((info,index)=>{
                                                                if(info.vehicle_added === 'completed' || info.vehicle_added === undefined){

                                                                    return(<p className="paddingTop0 paddingBottomp0">{info.field_name? info.field_name+': ':''} <b>{info.field_type === 'string'?info.text_value : converDateToLocal(info.date_value,timeZone.utc_offset,'ddmmyyyy')}</b></p>)
                                                                }else if(info.vehicle_added === true  && !this.props.isClientPage && disableVehicle === false){
                                                                    return(<div className="padding-top-10"><a className="textUl text-red spanPointer"  onClick={(e) => this.addRemoveVehicle('remove', crew.schedule_id, info.vehicle_master_id)}><span> {info.shift_status} {stringFormat(LBL_REMOVE_CREW_VEHICLE,lblCrew)}</span></a></div>)
                                                                }
                                                            })} */} 

                                                            {(showVehicleSelection && vehicle.vehicle_added === false && !this.props.isClientPage && disableVehicle === false) ?
                                                                <div className="padding-top-10">
                                                                    <a className="textUl blueText spanPointer"  onClick={(e) => this.addRemoveVehicle('add', crew.schedule_id, vehicle.vehicle_master_id)}><span> {vehicle.shift_status} {stringFormat(LBL_SELECT_VEHICLE,lblCrew)}</span></a>
                                                                    <div style={{marginTop: "5px",marginBottom: "8px"}}>{showStaffVehicle(vehicle,timeZone)}</div>
                                                                    </div> : <></>
                                                            }

                                                            {(vehicle.vehicle_added === 'completed' || vehicle.vehicle_added === undefined) ? 
                                                                <p className="paddingTop0 paddingBottomp0">{vehicle.field_name? vehicle.field_name+': ':''} <b>{vehicle.field_type === 'string'?vehicle.text_value : converDateToLocal(vehicle.date_value,timeZone.utc_offset,'ddmmyyyy')}</b></p> : 
                                                                (vehicle.vehicle_added === true  && !this.props.isClientPage && disableVehicle === false) ? 
                                                                    <div className="padding-top-10">
                                                                        <div style={{marginTop: "5px",marginBottom: "8px"}}>{showStaffVehicle(vehicle,timeZone)}</div>
                                                                        <a className="textUl text-red spanPointer"  onClick={(e) => this.addRemoveVehicle('remove', crew.schedule_id, vehicle.vehicle_master_id)}><span> {vehicle.shift_status} {stringFormat(LBL_REMOVE_CREW_VEHICLE,lblCrew)}</span></a></div>: <></>
                                                            }
                                                            </div>)
                                                        })
                                                    }

                                                   {showVehicleSelection && crew.shift_status !== 7 && crew.shift_status !== 8 && !isClientPage && crewVehicleAdded===false && !crew.added_affiliate_vehicle && affAvailVeh.length>0 && crew.staff_vehicle && crew.staff_vehicle.length>0 && !isSuperAdmin && 
                                                        <p className="or">{LBL_OR}</p>
                                                   }

                                                   {crew.added_affiliate_vehicle && 
                                                        <div className="vehicleInfo">{showSelectedVehicle(crew.added_affiliate_vehicle.affiliatevehicledetails_set,timeZone)}
                                                        </div>
                                                              
                                                   }
                                                   {crew.shift_status !== 7 && crew.shift_status !== 8 && !isClientPage && crew.added_affiliate_vehicle && !isSuperAdmin && 
                                                        <div className="aff-veh-padd padding-top-10"><a className="textUl text-red spanPointer"  onClick={(e) => this.removeAffVehChange(e,crew.schedule_id, crew.added_affiliate_vehicle.id)}><span> {LBL_REMOVE_AFF_VEHICLE}</span></a></div>
                                                    }  
                                                   {showVehicleSelection && crew.shift_status !== 7 && crew.shift_status !== 8 && !isClientPage && crewVehicleAdded===false && !crew.added_affiliate_vehicle && affAvailVeh.length>0 && !isSuperAdmin && 
                                                            <div className="vehicle-select">
                                                                <label>{LBL_AFF_VEH_DETAILS}</label>
                                                                <div className="form-group select-input">
                                                                    <select name={"affVehicleSelect_"+index} onChange={(e) => this.onHandleVehChange(e,crew.schedule_id)} value={''}>
                                                                        <option value=''>{LBL_NOT_SELECTED}</option>
                                                                        {   affAvailVeh.map((vehItem,vehIndex)=>{
                                                                            let text_value = ''
                                                                            if(vehItem.affiliatevehicledetails_set.length === 1){
                                                                                if(vehItem.affiliatevehicledetails_set[0].text_value){
                                                                                    text_value = vehItem.affiliatevehicledetails_set[0].text_value;
                                                                                }else if(vehItem.affiliatevehicledetails_set[0].date_value){
                                                                                    text_value = converDateToLocal(vehItem.affiliatevehicledetails_set[0].date_value,timeZone.utc_offset,'ddmmyyyy');
                                                                                }
                                                                            }else if(vehItem.affiliatevehicledetails_set.length>1){
                                                                                if(vehItem.affiliatevehicledetails_set[0].text_value){
                                                                                    text_value = vehItem.affiliatevehicledetails_set[0].text_value+' - ';
                                                                                }else if(vehItem.affiliatevehicledetails_set[0].date_value){
                                                                                    text_value = converDateToLocal(vehItem.affiliatevehicledetails_set[0].date_value,timeZone.utc_offset,'ddmmyyyy')+' - ';
                                                                                }
                                                                                if(vehItem.affiliatevehicledetails_set[1].text_value){
                                                                                    text_value = text_value+vehItem.affiliatevehicledetails_set[1].text_value;
                                                                                }else if(vehItem.affiliatevehicledetails_set[1].date_value){
                                                                                    text_value = text_value+converDateToLocal(vehItem.affiliatevehicledetails_set[1].date_value,timeZone.utc_offset,'ddmmyyyy');
                                                                                }
                                                                            }
                                                                                return(
                                                                                        <option value={vehItem.id}>{text_value}</option>
                                                                                )
                                                                            })
                                                                 
                                                                        }
                                                                        
                                                                    </select>
                                                                </div>
                                                            </div>
                                                   } 

                                                    </div> 
                                                    : <></>
                                                    }
                                                    
                                                    
                                                    
                                                </div>

                                            
                                            </div>  
                                            )
                                        })
                                        }                                                                                
                                    </div>       
                                </Tab.Pane>

                            </Tab.Content>  
                        </Tab.Container>
                    </div>
                </Scrollbars>
                <ModalWindow ref={this.modalConfirmRemove} header="Remove Crew" type="confirm" deleteConfirmedItem={this.crewRemoveConfirmed} resetModalForm={this.onModalFormReset}>
                    {MSG_CONFIRMATION}
                </ModalWindow>
            </>
        )
    }
}

const mapStateToProps = (state) => {

    return {   
        shiftSkillAllCrewData: state.event.shiftSkillAllCrewData,
        shiftSliderDetails: state.event.shiftSliderDetails,
        shiftSliderStatus: state.event.shiftSliderStatus,
        shiftSliderActivity: state.event.shiftSliderActivity,  
        shiftSliderErrorData: state.event.shiftSliderErrorData,
        shiftSkillCrewData: state.event.shiftSkillCrewData,                 
        shiftSkillCrewStatus: state.event.shiftSkillCrewStatus,      
        shiftSkillCrewActivity: state.event.shiftSkillCrewActivity,       
        shiftSkillCrewErrorData: state.event.shiftSkillCrewErrorData,  

        crewScheduleShiftStatus: state.crews.crewScheduleShiftStatus,
        crewScheduleShiftStatusActivity: state.crews.crewScheduleShiftStatusActivity,
        crewScheduleShiftStatusErrorData: state.crews.crewScheduleShiftStatusErrorData,

        crewScheduleShiftCheckInStatus: state.crews.crewScheduleShiftCheckInStatus,
        crewScheduleShiftCheckInActivity: state.crews.crewScheduleShiftCheckInActivity,
        crewScheduleShiftCheckInErrorData: state.crews.crewScheduleShiftCheckInErrorData,

        crewScheduleShiftCheckOutStatus: state.crews.crewScheduleShiftCheckOutStatus,
        crewScheduleShiftCheckOutActivity: state.crews.crewScheduleShiftCheckOutActivity,
        crewScheduleShiftCheckOutErrorData: state.crews.crewScheduleShiftCheckOutErrorData,

        crewRemovalStatus: state.crews.crewRemovalStatus,
        crewRemovalActivity: state.crews.crewRemovalActivity,
        crewRemovalErrorData: state.crews.crewRemovalErrorData,
        status:state.event.status,
        subactivity:state.event.subactivity,
        discActivity:state.event.discActivity,
        activity:state.event.activity,
        eventShiftCrewList: state.event.eventShiftCrewList,
        affAvailVeh:state.event.affAvailVeh,
        affAvailVehData:state.event.affAvailVehData,
        affVehActivity:state.event.affVehActivity

    }
};
 
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        shiftSummaryAction:shiftSummaryAction, 
        shiftSummaryAllCrewAction:shiftSummaryAllCrewAction,
        crewScheduleShiftStatusAction: crewScheduleShiftStatusAction, 
        crewScheduleShiftCheckInAction: crewScheduleShiftCheckInAction, 
        crewScheduleShiftCheckOutAction: crewScheduleShiftCheckOutAction,
        crewRemovalFromShiftAction: crewRemovalFromShiftAction,
        listEventShiftCrewAction:listEventShiftCrewAction,
        availableAffVehicleAction:availableAffVehicleAction,
        addAffVehicleShiftAction:addAffVehicleShiftAction,
        removeAffVehicleShiftAction:removeAffVehicleShiftAction,
        addRemoveVehicleFromShiftAction:addRemoveVehicleFromShiftAction
    },dispatch); // shiftSkillCrewListAction:shiftSkillCrewListAction,
}
export default connect(mapStateToProps,mapDispatchToProps)(ShiftDetailSlider);